var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { UploadFileStatus } from './interfaces/UploadFileStatus';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages, cancel, retry, remove } from './messages';
/**
 * @hidden
 */
var UploadListActionButton = /** @class */ (function (_super) {
    __extends(UploadListActionButton, _super);
    function UploadListActionButton(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonClassNames = function (type) {
            var _a = _this.state, actionFocused = _a.actionFocused, retryFocused = _a.retryFocused;
            return classNames('k-button k-upload-action', _this.props.disabled ? 'k-state-disabled' : '', (actionFocused && type === 'action') || (retryFocused && type === 'retry') ? 'k-state-focused' : '');
        };
        _this.onRetryFocus = function () {
            _this.setState({
                retryFocused: true
            });
        };
        _this.onRetryBlur = function () {
            _this.setState({
                retryFocused: false
            });
        };
        _this.onActionFocus = function () {
            _this.setState({
                actionFocused: true
            });
        };
        _this.onActionBlur = function () {
            _this.setState({
                actionFocused: false
            });
        };
        _this.onActionClick = function () {
            var _a = _this.props, status = _a.status, uid = _a.uid, disabled = _a.disabled, onCancel = _a.onCancel, onRemove = _a.onRemove;
            if (disabled || status === UploadFileStatus.Removing) {
                return;
            }
            if (status === UploadFileStatus.Uploading) {
                onCancel.call(undefined, uid);
            }
            else {
                onRemove.call(undefined, uid);
            }
        };
        _this.onRetryClick = function () {
            var _a = _this.props, uid = _a.uid, disabled = _a.disabled, onRetry = _a.onRetry;
            if (disabled) {
                return;
            }
            onRetry.call(undefined, uid);
        };
        _this.state = {
            retryFocused: false,
            actionFocused: false
        };
        return _this;
    }
    UploadListActionButton.prototype.actionButtonTitle = function (status, localizationService) {
        if (status === UploadFileStatus.Uploading) {
            return localizationService.toLanguageString(cancel, messages[cancel]);
        }
        return localizationService.toLanguageString(remove, messages[remove]);
    };
    UploadListActionButton.prototype.retryButtonTitle = function (localizationService) {
        return localizationService.toLanguageString(retry, messages[retry]);
    };
    UploadListActionButton.prototype.render = function () {
        var _a = this.props, status = _a.status, progress = _a.progress;
        var actionButtonClassNames = classNames('k-icon', status === UploadFileStatus.Uploading ? 'k-cancel k-i-deny' : '', status !== UploadFileStatus.Uploading ? 'k-delete k-i-x' : '');
        var isRetryVisible = status === UploadFileStatus.UploadFailed;
        var isProgressVisible = status === UploadFileStatus.Uploading;
        var isActionHidden = (status === UploadFileStatus.Uploaded || status === UploadFileStatus.Initial) &&
            !this.props.async.removeUrl;
        var localizationService = provideLocalizationService(this);
        var percent = '%';
        return (React.createElement("strong", { className: 'k-upload-status' },
            isProgressVisible ?
                React.createElement("span", { className: 'k-upload-pct' },
                    progress,
                    percent) :
                undefined,
            isRetryVisible ?
                (React.createElement("button", { type: "button", tabIndex: -1, className: this.buttonClassNames('retry'), onFocus: this.onRetryFocus, onBlur: this.onRetryBlur, onClick: this.onRetryClick },
                    React.createElement("span", { "aria-label": this.retryButtonTitle(localizationService), title: this.retryButtonTitle(localizationService), className: 'k-icon k-retry k-i-refresh-sm' }))) :
                undefined,
            !isActionHidden ?
                (React.createElement("button", { type: "button", tabIndex: -1, className: this.buttonClassNames('action'), onFocus: this.onActionFocus, onBlur: this.onActionBlur, onClick: this.onActionClick },
                    React.createElement("span", { "aria-label": this.actionButtonTitle(status, localizationService), title: this.actionButtonTitle(status, localizationService), className: actionButtonClassNames }))) :
                undefined));
    };
    return UploadListActionButton;
}(React.Component));
export { UploadListActionButton };
registerForLocalization(UploadListActionButton);
//# sourceMappingURL=UploadListActionButton.js.map